// extracted by mini-css-extract-plugin
export default {"Cart":"Cart_Cart__3MESu","Cart__count":"Cart_Cart__count__hACQj","Cart__total":"Cart_Cart__total__34xnG","Cart__amount":"Cart_Cart__amount__lBtrm"};